/**
 * Pretendard 폰트 사용 가능 여부를 확인하는 함수
 * 한국과 미국에서만 Pretendard 폰트를 사용하고, 그 외 국가에서는 시스템 폰트를 사용합니다.
 * @returns {boolean} Pretendard 폰트 사용 가능 여부
 */
export const isPretendardAvailable = (language: 'ko' | 'en' | 'ja' | 'th' | string): boolean => {
  if (language === 'ko' || language === 'en') {
    return true;
  }
  return false;
}; 